import { casinoApi } from "../api/casino.api";
import { gameApi } from "../api/game.api";
import { homeApi } from "../../home/api/home.api";
import { toastService as toast } from "../../../components/ui/toast/toast.service";
import { GameLaunchRequest } from "../models/requests/gameLaunchRequest";
import { FreespinUserRequest } from "../models/requests/freespinUserRequest";
import { GetQtechFreeSpinRequest } from "../models/requests/getQtechFreeSpinRequest";
import { GetQtechFreeSpinResponse } from "../models/responses/getQtechFreeSpinResponse";
import { QtechFreeSpinPromoCodeRequest } from "../models/requests/qtechFreeSpinPromoCodeRequest";
import { QtechFreeSpinCreateRequest } from "../models/requests/qtechFreeSpinCreateRequest";
import common from "../../../utils/common";
import errorModal from "../../../services/errorModal.service";
import { AccessMode } from "../../../models/constants/accessMode";
import { ExchangeWindowClose } from "../../../assets/js/common";
import { commonService } from "../../../services/common.service";
import { localStorageService } from "../../../services";

/* QTech Free Spin Games*/
export async function QtechFreeSpin(
  userId: string,
  gameId: string,
  gameCode: string,
  accessModeSource: string
): Promise<string | null> {
  const request: FreespinUserRequest = {
    userId,
    gameId,
  };
  const result = await casinoApi.qtechFreeSpinGames(request);
  if (result.data) {
    if (result.isSuccess) {
      const freeSpinGame = result?.data;
      if (freeSpinGame.isfreespin) {
        let getQtechFreeSpinResponse: GetQtechFreeSpinResponse | null = null;
        const qtechBonusId = freeSpinGame.qtechbonusid ?? null;
        if (qtechBonusId != null && qtechBonusId !== "") {
          const qtechFreeSpinRequest: GetQtechFreeSpinRequest = {
            bonusId: qtechBonusId,
            playerId: userId,
          };
          const freeSpinBonusHistory =
            await casinoApi.getQtechFreeRounds(qtechFreeSpinRequest);
          if (
            freeSpinBonusHistory.isSuccess &&
            freeSpinBonusHistory.data != null
          ) {
            getQtechFreeSpinResponse = freeSpinBonusHistory.data;
          }
        }
        const shouldGetPromoCode =
          !getQtechFreeSpinResponse?.status ||
          getQtechFreeSpinResponse.status !== "IN_PROGRESS" ||
          !qtechBonusId;
        if (shouldGetPromoCode) {
          const qtechFreeSpinPromoCodeRequest: QtechFreeSpinPromoCodeRequest = {
            bonusId: freeSpinGame.bonusid,
            promoCode: freeSpinGame.promocode,
            bonusWalletTransactionId: freeSpinGame.bonuswallettransactionid,
          };
          const getfreespinPromoCode = await casinoApi.getLatestPromoCode(
            qtechFreeSpinPromoCodeRequest,
          );
          const freeSpinData = getfreespinPromoCode.data;
          const response = freeSpinData?.response;
          if (
            response != null &&
            response.promocode &&
            !response.qtechbonusid
          ) {
            const freeSpinCreateRequest: QtechFreeSpinCreateRequest = {
              promocode: response.promocode,
              bonusId: crypto.randomUUID(),
              gameId: gameCode,
              userId,
              id: response.id,
              totalBetValue: response.totalbetvalue,
            };
            await casinoApi.qtechFreeSpinCreate(freeSpinCreateRequest);
            return await LaunchQtechGame(gameCode, accessModeSource);
          } else {
            return await LaunchQtechGame(gameCode, accessModeSource);
          }
        } else {
          return await LaunchQtechGame(gameCode, accessModeSource);
        }
      } else {
        return await LaunchQtechGame(gameCode, accessModeSource);
      }
    } else {
      errorModal.showErrorModal(result.statusCode, result.message);
      return null
    }
  } else {
    return await LaunchQtechGame(gameCode, accessModeSource);
  }
}

/* Launch Qtech Game */
export async function LaunchQtechGame(gameId: string, accessModeSource: string): Promise<string | null> {
  const fetchCommonConfigResponse = await commonService.fetchCommonConfig();  
  const currentUrl = window.location.pathname.split("/");
  if (currentUrl[3] === "gamelaunch") return null;
  const device = common.detectDeviceType()
  const deviceType = device === "desktop" ? "desktop" : "mobile";
  const ipAddress = fetchCommonConfigResponse.data?.ip!;
    const userId = localStorageService.getItem<string>("providerUserId") ?? "null";
    const fullName = localStorageService.getItem<string>("FullName");

  const request: GameLaunchRequest = {
    gameId,
    playerId: userId ?? undefined,
    displayName: fullName ?? "dev",
    currency: "INR",
    country: "IN",
    returnUrl: window.location.origin,
    lang: "en-US",
    mode: "real",
    device: deviceType === "desktop" ? "desktop" : "mobile",
    ipAddress,
    accessMode: accessModeSource.toLowerCase() === AccessMode.App.toLowerCase() ? 2 : 1,
  };

  const result = await casinoApi.launchQtechGame(request);
  if (result.isSuccess && result.data?.response) {
    await transferFundFromExchange();
    const gameUrl = result.data.response;
    localStorageService.setItem("gameUrl", gameUrl);
    return result.data?.response;
  } else {
    errorModal.showErrorModal(result.statusCode, result.message || "Failed to launch Casino Qtech game.");
    return null;
  }
}
async function transferFundFromExchange() {
  const balanceResponse = await homeApi.fetchUserBalance();
  if (balanceResponse.isSuccess) {
    if (
      balanceResponse.data?.is9WOn ||
      (balanceResponse.data?.exchangeBalance &&
        balanceResponse.data?.exchangeBalance > 0)
    ) {
      const transferFund = await gameApi.transferFundFromExchange();
      if (!transferFund.isSuccess) {
        errorModal.showErrorModal(transferFund.statusCode, transferFund.message, false);
      }
      else{
        await ExchangeWindowClose();
      }
    }
  }
}
